module.exports = __webpack_public_path__ + "static/media/pin_mapa.a9fa697d.png";